var map = {
	"./galerie1.jpg": 2971,
	"./galerie2.jpg": 5276,
	"./galerie3.jpg": 2649,
	"./galerie4.jpg": 58,
	"./galerie5.jpg": 9063,
	"app/images/pratique/galerie1.jpg": 2971,
	"app/images/pratique/galerie2.jpg": 5276,
	"app/images/pratique/galerie3.jpg": 2649,
	"app/images/pratique/galerie4.jpg": 58,
	"app/images/pratique/galerie5.jpg": 9063
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4817;